const childRoutes = (prop) => [
    {
        path: 'dashboard',
        name: prop + '.dashboard',
        meta: { auth: true },
        component: () => import('../pages/social-organization/Dashboard.vue')
    },
    {
        path: 'social-organization-import-raw',
        name: prop + '.social_organization_import',
        meta: { auth: true },
        component: () => import('../pages/social-organization-import-raw/List.vue')
    },
    {
        path: 'social-organization-import-raw-report',
        name: prop + '.social_organization_import_raw_report',
        meta: { auth: true },
        component: () => import('../pages/social-organization-import-raw-report/List.vue')
    },
    {
        path: 'social-organization-import',
        name: prop + '.social_organization_import',
        meta: { auth: true },
        component: () => import('../pages/social-organization-import/List.vue')
    },
    {
        path: 'social-organization',
        name: prop + '.social_organization',
        meta: { auth: true },
        component: () => import('../pages/social-organization/List.vue')
    },
    {
        path: 'social-organization-form',
        name: prop + '.social_organization_form',
        meta: { auth: true },
        component: () => import('../pages/social-organization/Form.vue')
    },
    {
        path: 'details',
        name: prop + '.social_organization_form',
        meta: { auth: true },
        component: () => import('../pages/social-organization/Details.vue')
    }
]

const routes = [{
    path: '/grant-allowance-service/social-organization',
    name: 'grant_allowance_service.social_organization',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.social_organization')
}]

export default routes
